export default function deleteRestriction({ graphql, props, state }) {
  const { selectedFiles, tags: { showShared } } = state.get('media')
  const ids = showShared ? selectedFiles : [props.id]

  ids.forEach(id => {
    graphql.mutate(`{
        deleteRestriction(id: "${id}"){
          id
        }
      }`)
  })
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/deleteRestriction.js